import { Zap, Battery, Sun, Wind, CheckCircle, Clock, Award, Users } from 'lucide-react'
import ServicePageLayout from '../components/ServicePageLayout'
import { useTranslation } from 'react-i18next'
import SEO from '../components/SEO'
import { serviceSEOData } from '../utils/serviceSEO'
import hero1 from '../assets/Services/power-generation/hero-1.jpg'
import hero2 from '../assets/Services/power-generation/hero-2.jpg'
import hero3 from '../assets/Services/power-generation/hero-3.jpg'
import solarPumping from '../assets/Services/power-generation/solar-pumping.jpg'
import windTurbine from '../assets/Services/power-generation/wind-turbine.jpg'
import generator from '../assets/Services/power-generation/generator.jpg'
import generatorSolution from '../assets/Services/power-generation/generator_solution.avif'

const PowerGeneration = () => {
  const { t } = useTranslation()

  const service = {
    heroSlides: [
      {
        image: hero1,
        title: t('services.powerGeneration.heroSlides.slide1.title'),
        subtitle: t('services.powerGeneration.heroSlides.slide1.subtitle'),
        description: t('services.powerGeneration.heroSlides.slide1.description')
      },
      {
        image: hero2,
        title: t('services.powerGeneration.heroSlides.slide2.title'),
        subtitle: t('services.powerGeneration.heroSlides.slide2.subtitle'),
        description: t('services.powerGeneration.heroSlides.slide2.description')
      },
      {
        image: hero3,
        title: t('services.powerGeneration.heroSlides.slide3.title'),
        subtitle: t('services.powerGeneration.heroSlides.slide3.subtitle'),
        description: t('services.powerGeneration.heroSlides.slide3.description')
      }
    ],
    introText: t('services.powerGeneration.introText'),
    stats: [
      { value: t('services.powerGeneration.stats.reliability'), label: t('services.powerGeneration.stats.cleanEnergy') },
      { value: t('services.powerGeneration.stats.warranty'), label: t('services.powerGeneration.stats.warrantyLabel') },
      { value: t('services.powerGeneration.stats.downtime'), label: t('services.powerGeneration.stats.fuelRequired') },
      { value: t('services.powerGeneration.stats.support'), label: t('services.powerGeneration.stats.operation') }
    ],
    capabilities: [
      t('services.powerGeneration.capabilities.solarEnergy'),
      t('services.powerGeneration.capabilities.solarPumping'),
      t('services.powerGeneration.capabilities.windTurbine'),
      t('services.powerGeneration.capabilities.generator'),
      t('services.powerGeneration.capabilities.gridIntegration'),
      t('services.powerGeneration.capabilities.energyStorage'),
      t('services.powerGeneration.capabilities.monitoring'),
      t('services.powerGeneration.capabilities.hybridSystems')
    ],
    services: [
      {
        icon: Sun,
        title: t('services.powerGeneration.servicesList.solarEnergy.title'),
        description: t('services.powerGeneration.servicesList.solarEnergy.description'),
        image: solarPumping
      },
      {
        icon: Zap,
        title: t('services.powerGeneration.servicesList.solarPumping.title'),
        description: t('services.powerGeneration.servicesList.solarPumping.description'),
        image: windTurbine
      },
      {
        icon: Wind,
        title: t('services.powerGeneration.servicesList.windTurbine.title'),
        description: t('services.powerGeneration.servicesList.windTurbine.description'),
        image: generator
      },
      {
        icon: Battery,
        title: t('services.powerGeneration.servicesList.generator.title'),
        description: t('services.powerGeneration.servicesList.generator.description'),
        image: generatorSolution
      }
    ],
    workflow: [
      {
        step: "01",
        title: t('services.powerGeneration.workflow.step1.title'),
        description: t('services.powerGeneration.workflow.step1.description')
      },
      {
        step: "02",
        title: t('services.powerGeneration.workflow.step2.title'),
        description: t('services.powerGeneration.workflow.step2.description')
      },
      {
        step: "03",
        title: t('services.powerGeneration.workflow.step3.title'),
        description: t('services.powerGeneration.workflow.step3.description')
      },
      {
        step: "04",
        title: t('services.powerGeneration.workflow.step4.title'),
        description: t('services.powerGeneration.workflow.step4.description')
      }
    ]
  }

  return (
    <>
      <SEO {...serviceSEOData['power-generation']} url="/services/power-generation" />
      <ServicePageLayout
        title={service.heroSlides[0].title}
        subtitle={service.heroSlides[0].subtitle}
        description={service.heroSlides[0].description}
        backgroundImages={service.heroSlides.map(slide => slide.image)}
        heroSlides={service.heroSlides}
        introText={service.introText}
        capabilities={service.capabilities}
        services={service.services}
        stats={service.stats}
        workflow={service.workflow}
      />
    </>
  )
}

export default PowerGeneration